import React, { useEffect } from 'react';
import InputMask from 'react-input-mask';

import InputBase from 'apps/auth/components/form-multi/InputBase';
import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';

function useOTP(onChange) {
    useEffect(() => {
        if ('OTPCredential' in window) {
            const input = document.querySelector('input[autocomplete="one-time-code"]');
            if (!input) return;
            // Cancel the WebOTP API if the form is submitted manually.
            const ac = new AbortController();
            // Invoke the WebOTP API
            logInfo('Invoke the WebOTP API', navigator);
            if (navigator && navigator.credentials) {
                logInfo('navigator.credentials:', navigator.credentials);
                navigator.credentials
                    .get({
                        otp: { transport: ['sms'] },
                        signal: ac.signal,
                    })
                    .then((otp) => {
                        logInfo('otp:', otp);
                        onChange(otp.code);
                    })
                    .catch((err) => {
                        logInfo(err);
                    });
            }
        }
    }, []);
}

const InputSMS = (props) => {
    const changeValue = (currentValue) => {
        logInfo('currentValue event:', currentValue);
        const field = props.field;
        if (!field.isReadOnly) {
            const value = currentValue ? currentValue.replace(/\D/g, '') : '';
            validationAndUpdateValue(props.formName, value, field, props.changeFormField).then(() => {
                if (props.onChangeHandler) {
                    props.onChangeHandler(value, field.name);
                }
            });
        }
    };

    const handlerChange = (e) => {
        e.preventDefault();
        changeValue(e.target.value);
    };

    useOTP((code) => changeValue(code));

    const beforeMaskedValueChange = (newState) => {
        const { value } = newState;
        let selection = newState.selection;
        const fieldValue = props.field?.value;
        if (selection !== null) {
            selection.start = fieldValue?.length || 0;
            selection.end = fieldValue?.length || 0;
        }
        return {
            value,
            selection,
        };
    };

    return (
        <InputMask
            value={props.field.value || ''}
            mask={props.mask || '99999'}
            maskChar="•"
            id={props.id}
            readOnly={props.readOnly ? props.readOnly : false}
            onFocus={props.onFocus}
            onChange={handlerChange}
            beforeMaskedValueChange={beforeMaskedValueChange}
            alwaysShowMask={true}
            autoFocus={true}
            type="text"
            inputMode="numeric"
            auto-complete="one-time-code"
            autoComplete="one-time-code"
            data-testid="input-sms-input"
        />
    );
};

InputSMS.propTypes = inputPropType(['text', 'tel']);

export default InputBase(InputSMS);
